import Register from '../utils/Register';

export default class BootstrapTooltips {

	constructor ($container) {
		document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
	}

    static init ($container) {
		new BootstrapTooltips($container);
    }
}

(new Register()).registerCallback(BootstrapTooltips.init, 'BootstrapTooltips.init');